import axios from 'axios';

export type ZipCodeResult = {
  address1: string; // "東京都",
  address2: string; // '港区'
  address3: string; // '南麻布'
  kana1: string; // 'ﾄｳｷｮｳﾄ'
  kana2: string; // 'ﾐﾅﾄｸ'
  kana3: string; // 'ﾐﾅﾐｱｻﾞﾌﾞ'
  prefcode: string; // '13'
  zipcode: string; // '1060047'
};

type ZipCodeNullResponse = {
  message: null;
  results: null;
  status: 200;
};

type ZipCodeSuccessResponse = {
  message: null;
  results: ZipCodeResult[];
  status: 200;
};

type ZipCodeErrorResponse = {
  message: string;
  results: null;
  status: 400;
};

type ZipCodeResponse =
  | ZipCodeNullResponse
  | ZipCodeSuccessResponse
  | ZipCodeErrorResponse;

export const fetchAddressByPosCode = async (
  posCode: string
): Promise<ZipCodeResponse> => {
  const res = await axios.get<ZipCodeResponse>(
    `https://zipcloud.ibsnet.co.jp/api/search?zipcode=${posCode}`
  );
  return res.data;
};
